module.exports = __webpack_public_path__ + "img/fdbckfirst.d32106f3.svg";